export default "__VITE_ASSET___19o8Czv__"